import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { Success } from "../../images/images";
import type { ContactType } from "./ContactForm";
import "./FormSubmittedModal.css";

const MESSAGES: Record<ContactType, string> = {
  general: "Thank you for reaching out. We’ve received your message and will respond promptly.",
  partnership: "Thank you for your interest in partnering with us. Our team will be in touch soon.",
  outreach: "We’ve received your request. Our team will review your needs and reach out to you.",
  volunteer: "Thank you for offering your time. We’ll be in touch about how you can serve.",
};

interface FormSubmittedModalProps {
  type: ContactType;
  onClose: () => void;
}

// Confirmation shown after a contact / partnership / outreach / volunteer form is sent
const FormSubmittedModal: React.FC<FormSubmittedModalProps> = ({ type, onClose }) => {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [onClose]);

  // Portal out so transformed (framer-motion) parents don't trap the fixed overlay
  return createPortal(
    <div className="form-submitted-backdrop" onClick={onClose}>
      <div
        className="form-submitted"
        role="dialog"
        aria-modal="true"
        aria-labelledby="form-submitted-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button type="button" className="form-submitted-close" onClick={onClose} aria-label="Close">
          &#10005;
        </button>
        <img src={Success} alt="" className="form-submitted-img" />
        <h2 id="form-submitted-title" className="form-submitted-title">
          Form Submitted
        </h2>
        <p className="form-submitted-desc">{MESSAGES[type]}</p>
        <button type="button" className="form-submitted-btn" onClick={onClose} autoFocus>
          Done
        </button>
      </div>
    </div>,
    document.body
  );
};

export default FormSubmittedModal;
